
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Button, Card, CardActions, CardContent, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, MenuItem, TextField, Typography } from "@mui/material";

import { RootState } from "../../store";
import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { CrearTurno } from "../../connections/comun/TurnosConnection";
import { ConsultarUnidades } from "../../connections/comun/UnidadConnection";
import { ConsultarTiposTurno } from "../../connections/comun/TiposTurnoConnection";

import { Unidades } from "../../interfaces/comun/UnidadInterface";
import { CrearTurnoParams, TurnoProps } from "../../interfaces/comun/TurnoInterface";

import { Teclado } from "../../components/Teclado";

const defaultTurno: TurnoProps = { turno_id: 0, turno_numero: 0, turno_comentarios: '', turno_numero_cubiculo: 0, turno_estado: { id:0, nombre:''},turno_tipo: {id:0, nombre:'', nivel:''}, unidad : { id: 0, clave : '', nombre : '' }, ubicacion: { id: 0, nombre : '', numero : 0 } };

export const CrearTurnoPage = (  ) => { 
    
    const dispatch = useDispatch();

    const [openConfirmacion, setOpenConfirmacion] = useState( false );
    const [openTurnoConfirmacion, setOpenTurnoConfirmacion] = useState( false );

    const [loading, setLoading] = useState( false );

    const [tipoturno, setTipoturno] =useState(0)

    const[ unidad, setUnidad] = useState(0);
   
    const[ unidadArray, setUnidadArray] = useState<Unidades[]>([]);
    
    const[ observaciones, setObservaciones] = useState('');

    const { unidad: unidadRedux } = useSelector( ( state: RootState ) => state.auth );

    const [tiposTurnoArray, setTiposTurnoArray] = useState<any[]>( [] );

    const [turno, setTurno] = useState<TurnoProps>( defaultTurno ); 
    
    const [telefonoCelular, setTelefonoCelular] = useState<string>('');
    
    const handleValidateFields = () => {

        let valid = true;

        if( !unidadRedux && unidad === 0 ){  
            dispatch( openSnackbar({ message: 'Debe seleccionar una unidad', variant: 'warning' }));        
            valid = false;   
        }
        else if( tipoturno === 0 ) {   
            dispatch( openSnackbar({ message: 'Debe seleccionar el tipo de turno', variant: 'warning' }));        
            valid = false;           
        }
        else if( observaciones === '' && tipoturno === 3 ){          
            dispatch( openSnackbar({ message: 'Escribe las observaciones', variant: 'warning' }));        
            valid = false;
        }

        if( valid ){
            setOpenConfirmacion( true ); 
        }

    }
    
    const handleCrearTurno = async () => {       

        setLoading( true );
        
        const params: CrearTurnoParams = {
            turno_tipo_id: tipoturno, 
            unidad_id: unidadRedux?.id === 1 ? unidad : unidadRedux?.id ?? 0, 
            turno_telefono: telefonoCelular !== '' ? telefonoCelular : null,
            comentarios: observaciones, 
        };

        await CrearTurno( params ).then(resp => {

            const { success, message, data } = resp;

            if( success ){

                if( data ){
               
                    setTimeout(() => {
                        
                        setTurno( data );
                            
                        setOpenTurnoConfirmacion( true );   
                        setOpenConfirmacion( false ); 
                        setLoading( false );  

                        dispatch( openSnackbar({ message: message, variant: 'success' }));    
    
                    }, 500);                

                }
            }
            else {

                setLoading( false );
                setOpenConfirmacion( false ); 
                
                dispatch( openSnackbar({ message: message, variant: 'error' }));    
            }

        });
        
    }

    const handleCloseNuevoTurno = () => {

        setUnidad( 0 );
        setTipoturno( 0 );
        setObservaciones( '' );

        setOpenTurnoConfirmacion( false );  
        setOpenConfirmacion( false );
    }

    useEffect(() => {
    
        async function obtener(){

            await ConsultarUnidades().then( resp => {
                setUnidadArray( resp.data ?? [] );
            });
        }

        obtener();

    }, [])  
    
    useEffect(() => {
          
        async function obtenerTipoTurno(){

            await ConsultarTiposTurno().then( resp => {
                setTiposTurnoArray( resp.data ?? [] );
            });

        }
    
        obtenerTipoTurno();

    }, []) 

    return (

        <>   

            <Grid container spacing={3}>

                {
                    unidadRedux?.id !==1
                    &&
                        <Grid size={{ xs: 12, md: 12 }}>       
                                
                            <Typography variant="h4" color="white" textAlign={'center'} p={1} sx={{ bgcolor: '#0A192D', borderRadius: 3 }}>
                                { unidadRedux?.nombre } 
                            </Typography>     

                        </Grid>

                }

                
                <Grid size={{ xs: 12, md: 12 }} sx={ { display: 'flex', justifyContent: 'center', margin:'auto' } } >

                    <Card sx={{ width: 400, mt: 3, opacity:0.9 }} >
                
                        <CardContent>

                            {
                                unidadRedux?.id ===1
                                &&
                                    <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 3 }}>

                                        <FormControl fullWidth>                                            
                                            
                                            <TextField 
                                                id="select-unidad" 
                                                label="Unidad" 
                                                select
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: true,
                                                    },
                                                }} 
                                                value={unidad}
                                                onChange={ (e) => setUnidad( parseInt( e.target.value ?? '0' ) ) }
                                            >       
                                                <MenuItem value={0}>Seleccione una opción</MenuItem> 
                                                {
                                                    unidadArray?.map( ( { id, clave, nombre } ) => (
                                                        <MenuItem key={id} value={id}>{ clave } - { nombre }   </MenuItem>      
                                                    ))
                                                }          
                                                
                                            </TextField>

                                        </FormControl>   

                                    </Grid>
                            }                            

                            <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 3 }}> 

                                <FormControl fullWidth>

                                    <TextField 
                                        id="select-tipo-turno" 
                                        label="Tipo de turno" 
                                        select
                                        slotProps={{
                                            inputLabel: {
                                                shrink: true,
                                            },
                                        }} 
                                        value={tipoturno}
                                        onChange={ (e) => setTipoturno( parseInt( e.target.value ?? '0' ) ) }
                                    >

                                        <MenuItem value={0}>Seleccione una opción</MenuItem>  
                                        {
                                            
                                            tiposTurnoArray.map( ( item ) => (
                                                <MenuItem key={ item.id } value={ item.id }>{ item.nombre }</MenuItem>      
                                            ))
                                        }
                                    </TextField>
                                  
                                </FormControl>   

                            </Grid>

                            <Teclado onDataChange={ setTelefonoCelular } /> 
   
                            <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 3 }}>
                                
                                <FormControl fullWidth>

                                    <TextField
                                        fullWidth
                                        label="Observaciones"
                                        name="observaciones"
                                        variant="outlined"        
                                        multiline
                                        rows={4}                 
                                        slotProps={{
                                            inputLabel: {
                                                shrink: true,
                                            },
                                        }}
                                        value={ observaciones }
                                        onChange={ (e) => setObservaciones(  e.target.value ?? ''  ) }                           
                                    />

                                </FormControl>   

                            </Grid>

                        </CardContent>              

                        <CardActions sx={{ p: 3 }}>                  

                            <Button fullWidth variant="contained" onClick={ handleValidateFields } > 
                                Crear Turno
                            </Button>   
                                                    
                        </CardActions>

                    </Card>
                        
                </Grid>
                
                
                 {/* Inicia espacio para crear turno nuevo */}   

            </Grid>   
            
            <Dialog
                fullWidth
                maxWidth='xs'
                open={ openConfirmacion }
                onClose={ () => {} }
            >
                <DialogTitle>Confirmación</DialogTitle>

                <DialogContent>

                    <DialogContentText>
                       ¿Desea crear un nuevo turno?
                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button disabled={ loading } color="secondary" onClick={ handleCloseNuevoTurno }>Cancelar</Button>
                    <Button 
                        variant='contained' 
                        onClick={  handleCrearTurno } 
                        loading={ loading }
                    >
                        Aceptar
                    </Button>

                </DialogActions>

            </Dialog>     

            <Dialog
                fullWidth
                maxWidth='xs'
                open={ openTurnoConfirmacion }
                onClose={ () => {} }
            >
                <DialogContent>

                    <DialogContentText sx={{ textAlign: 'center', mt: 5 }} >

                        Se ha creado un nuevo turno con el número
                        <Typography variant="h1" sx={{ mt: 2 }}>
                            {
                                !unidadRedux
                                ?
                                    ( turno.unidad.clave ?? '' ) + '-' + String( turno.turno_numero ).padStart(3,'0')
                                :
                                    String( turno.turno_numero ).padStart(3,'0')
                            }
                        </Typography>

                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button variant='contained' onClick={ handleCloseNuevoTurno  } >
                        Aceptar
                    </Button>

                </DialogActions>

            </Dialog> 
        
        </>
    )
}